import omit from 'lodash/omit';
import merge from 'lodash/merge';

import {
  SET_SELECTED_PARAMETERS,
  RESET_SELECTED_PARAMETERS,
  SET_SELECTED_PARAMETERS_FILTER,
  RESET_SELECTED_PARAMETERS_FILTER,
  TOGGLE_SELECTED_PARAMETER_VISIBILITY
} from './types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_SELECTED_PARAMETERS:
      return action.parameters;
    case RESET_SELECTED_PARAMETERS:
      return null;
    case SET_SELECTED_PARAMETERS_FILTER:
      return merge({}, state, {
        [action.parameter]: action.payload
      });
    case RESET_SELECTED_PARAMETERS_FILTER:
      return { ...state,
        [action.parameter]: omit(
          state[action.parameter],
          [
            'filter',
            'filterType',
            'filterOptions'
          ]
        )
      };
    case TOGGLE_SELECTED_PARAMETER_VISIBILITY:
      return { ...state,
        [action.parameterName]: {
          ...state[action.parameterName],

          isVisible: !state[action.parameterName].isVisible
        }
      };
    default:
      return state;
  }
};
